import { createAction, props } from '@ngrx/store';
import { PatientHealthConcern } from '../../../models/patient-health-concern';

export const loadPatientHealthConcerns = createAction(
  '[Patient Health Concern] Load Patient Health Concerns',
  props<{ patientId: number }>()
);

export const loadPatientHealthConcernsSuccess = createAction(
  '[Patient Health Concern] Load Patient Health Concerns Success',
  props<{ healthConcerns: PatientHealthConcern[]; patientId: number; loadedAt: number }>()
);

export const loadPatientHealthConcernsFailure = createAction(
  '[Patient Health Concern] Load Patient Health Concerns Failure',
  props<{ error: unknown }>()
);

export const loadPatientHealthConcernById = createAction(
  '[Patient Health Concern] Load Patient Health Concern By Id',
  props<{ patientHealthConcernId: number }>()
);

export const loadPatientHealthConcernByIdSuccess = createAction(
  '[Patient Health Concern] Load Patient Health Concern By Id Success',
  props<{ healthConcern: PatientHealthConcern }>()
);

export const loadPatientHealthConcernByIdFailure = createAction(
  '[Patient Health Concern] Load Patient Health Concern By Id Failure',
  props<{ error: unknown }>()
);

export const invalidateHealthConcernsCache = createAction('[Patient Health Concern] Invalidate Health Concerns Cache');

export const recordPatientHealthConcernPrintEvent = createAction(
  '[Patient Health Concern] Record Print Event',
  props<{ patientId: number; patientHealthConcernIds: number[] }>()
);

export const recordPatientHealthConcernPrintEventSuccess = createAction(
  '[Patient Health Concern] Record Print Event Success'
);

export const recordPatientHealthConcernPrintEventFailure = createAction(
  '[Patient Health Concern] Record Print Event Failure',
  props<{ error: unknown }>()
);

export const recordPatientHealthConcernDetailPrintEvent = createAction(
  '[Patient Health Concern] Record Detail Print Event',
  props<{ patientId: number; patientHealthConcernId: number }>()
);

export const recordPatientHealthConcernDetailPrintEventSuccess = createAction(
  '[Patient Health Concern] Record Detail Print Event Success'
);

export const recordPatientHealthConcernDetailPrintEventFailure = createAction(
  '[Patient Health Concern] Record Detail Print Event Failure',
  props<{ error: unknown }>()
);
